module.exports = [
  'SalonService', 'RESTService', (SalonService, RESTService) ->
    (id) ->
      RESTService.service('stylists', SalonService.one(id))
]
